import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPricingPassportConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPricingPassportConfigEntity
